import dayjs from 'dayjs';

import { CourseEnrolmentState } from '../../types/common';

export const getChangeColor = (change: number) => {
  if (change > 0) {
    return 'success.main';
  }
  if (change < 0) {
    return 'error.main';
  }
  return 'grey';
};

const BAR_COLORS = [
  '#674ea7',
  '#e69138',
  '#6aa84f',
  '#3c78d8',
  '#45818e',
  '#cc0000',
  '#d6ba2b',
  '#101b7f',
  '#cc33a8',
  '#9a513b',
];

export const getColorFromYear = (year: string | number) => {
  const gradYearString = String(year);
  const lastDigit = gradYearString.slice(-1);
  return BAR_COLORS[Number(lastDigit)];
};

export const getTransparencyFromCourseState = (state: string) => {
  if (state === CourseEnrolmentState.Active) {
    // 100% opacity in HEX code
    return 'FF';
  }

  if (state === CourseEnrolmentState.OnTrial) {
    // 75% opacity in HEX code
    return 'BF';
  }

  // 50% opacity in HEX code
  return '80';
};

export const getDateAttributes = (datetime: number) => ({
  datetime,
  displayDate: dayjs(datetime).format('D-MMM'),
  displayDateWithYear: dayjs(datetime).format('D-MMM-YYYY'),
});

type EnrolmentCountAttributes = {
  [key: string]: number,
};

// Returns eg.
// {
//   2024#ACTIVE: 10,
//   2024#ON_TRIAL: 5,
//   2024: 15,
//   total: 15,
// }
export const getEnrolmentCountAttributes = (snapshotCounts: {
  [gradYear: string]: {
    [state: string]: number,
  },
}): EnrolmentCountAttributes => {
  const countsByGradYearAndState: {
    [key: string]: number,
  } = Object.keys(snapshotCounts).reduce((acc, gradYear) => {
    const countByState = snapshotCounts[gradYear];

    const activeCount = countByState[CourseEnrolmentState.Active] || 0;
    const trialCount = countByState[CourseEnrolmentState.OnTrial] || 0;

    return {
      ...acc,
      [`${gradYear}#${CourseEnrolmentState.Active}`]: activeCount,
      [`${gradYear}#${CourseEnrolmentState.OnTrial}`]: trialCount,
      [gradYear]: activeCount + trialCount,
    };
  }, {});

  // Tally total by summing the grad year sums
  const total = Object.keys(countsByGradYearAndState).reduce((acc, key) => {
    if (!key.includes('#')) {
      // If it contains #, it has a state specified
      return acc + countsByGradYearAndState[key];
    }
    return acc;
  }, 0);

  return {
    ...countsByGradYearAndState,
    total,
  };
};
